import React, { useState, useEffect, Component } from 'react'
import { useSelector, useDispatch } from 'react-redux'
import { makeStyles, withStyles } from '@material-ui/core/styles'
import Typography from '@material-ui/core/Typography'
import 'date-fns'
import SkeletonList from '../skeleton/skeletonList'
import {
  getAllRecommendationList,
  getRecommendationList,
  updateRecommendationList,
  deleteRecommendationList
} from '../../_redux/_actions/recommendationListActions'
import Button from '@material-ui/core/Button'
import Snackbar from '@material-ui/core/Snackbar'
import DeleteOutlinedIcon from '@material-ui/icons/DeleteOutlined';
import IconButton from '@material-ui/core/IconButton'
import DragIndicatorRoundedIcon from '@material-ui/icons/DragIndicatorRounded'
import {
  Dialog,
  DialogTitle,
  DialogActions,
} from '@material-ui/core'
import {
  List,
  ListItem,
  ListItemText,
  ListSubheader,
  ListItemSecondaryAction,
} from '@material-ui/core'
import RootRef from '@material-ui/core/RootRef'
import { DragDropContext, Droppable, Draggable } from 'react-beautiful-dnd'
import Grid from '@material-ui/core/Grid'
import MuiAccordion from '@material-ui/core/Accordion'
import MuiAccordionSummary from '@material-ui/core/AccordionSummary'
import MuiAccordionDetails from '@material-ui/core/AccordionDetails'
import ExpandMoreIcon from '@material-ui/icons/ExpandMore'
import RecommendationDialog from './recommendationDialog.jsx'
import queryString from 'query-string'
import { history } from '../../_redux/_store/history'
import MuiAlert from '@material-ui/lab/Alert'
import SkeletonPaper from '../skeleton/SkeletonPaper'

function Alert(props) {
  return <MuiAlert elevation={6} variant='filled' {...props} />
}

const Accordion = withStyles(() => ({
  root: {},
}))(MuiAccordion)

const AccordionDetails = withStyles(() => ({
  root: {
    padding: '42px 16px 16px',
    flexDirection: 'column',
    justifyContent: 'space-between',
  },
}))(MuiAccordionDetails)

const AccordionSummary = withStyles(() => ({
  root: {
    backgroundColor: '#666666',
    color: 'white',
    marginTop: '20px',
  },
}))(MuiAccordionSummary)

const styles = (theme) => ({
  root: {
    margin: 0,
    padding: theme.spacing(2),
  },
  closeButton: {
    position: 'absolute',
    right: theme.spacing(1),
    top: theme.spacing(1),
    color: theme.palette.grey[500],
  },
  container: {
    display: 'flex',
    flexWrap: 'wrap',
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
  },
})

const useStyles = makeStyles((theme) => ({
  search: {
    width: '100%',
    padding: theme.spacing(1, 1, 1, 1),
    [theme.breakpoints.up('sm')]: {
      width: '35ch',
      '&:focus': {
        width: '35ch',
        outline: 'none',
      },
    },
  },
  editButton: {
    width: '20px',
    marginLeft: '0px !important',
  },
  textEditButton: {
    color: 'blue',
    '&:hover': {
      backgroundColor: 'inherit',
    },
  },
  dragIcon: {
    color: '#52A1C2',
    verticalAlign: 'bottom',
    marginRight: '20px'
  },
  listItem:{
    background:'#F6F6F6'
  }
}))

function RecommendationList({ scope }) {
  const classes = useStyles()
  const recommendation = useSelector((state) => state.recommendation)
  const [allRecommendation, setAllRecommendation] = useState('')
  const [recommendationlistitems, setRecommendationlistitems] = useState('')
  const [error, setErrorState] = useState()
  const dispatch = useDispatch()
  const [edited, setEdited] = useState(false)
  const [open, setOpen] = React.useState(false)
  const [alwaysHide, setalwaysHide] = React.useState(false)
  const [scroll, setScroll] = React.useState('paper')
  const queryValues = queryString.parse(history.location.search)
  const {machine_type, hmi_type} = queryValues;
  const findingRuleId = queryValues.findingRuleId
  const [errorflag, setErrorFlag] = useState(false)
  const [errormsg, setErrorMsg] = useState('')
  const [notificationFlag, setNotificationFlag] = useState({state : false, message : ''})
  const [errorseverity, setErrorSeverity] = useState('success')
  const [newlyAddedRecommendation , setNewlyAddedRecommendation] = useState([])
  const [openClearAllConfirmation, setOpenClearAllConfirmation] = useState(false)

  useEffect(() => {
    if(!history.location.search)
    {
      history.push('/rules');
      return;
    }
    dispatch(getRecommendationList(findingRuleId,machine_type,hmi_type,scope))
    dispatch(getAllRecommendationList(machine_type,hmi_type))
    return(()=>{
      window.sessionStorage.removeItem("recommendation_draft")
    })
  }, [])

  useEffect(() => {
    if (recommendation.recommendation) {
      setRecommendationlistitems(recommendation.recommendation)
      setAllRecommendation(recommendation.allRecommendation)
    }
    if(window.sessionStorage.getItem("recommendation_draft")){
      setRecommendationlistitems(JSON.parse(window.sessionStorage.getItem("recommendation_draft")));
    }
  }, [recommendation])

  const handleRecommendationDone = () => {
    var rec_list = []
    recommendationlistitems && recommendationlistitems.map((recommendationlistitem, index) => {
      rec_list.push({ id: recommendationlistitem.id, priority: index })
    })
    if (rec_list.length > 0) {
      const body = {
        scoped_finding_rule_id: findingRuleId,
        scope: scope,
        recommendations: rec_list
      }
      Promise.resolve(dispatch(updateRecommendationList(body, machine_type,hmi_type))).then(() => {
        setTimeout(() => {
          dispatch(getRecommendationList(findingRuleId,machine_type,hmi_type, scope))
        }, 2000);
      }
      )
      setErrorSeverity('success')
      setNotificationFlag({state: true, message: "Recommendation has been saved successfully"})
      setEdited(false)
    } 
    else 
    {
      callErrorHandling('Please add Recommendation', 'error')
    }
  }

  const handleDiscard = () => {
    let savedRecommendations = recommendationlistitems && recommendationlistitems.filter(item => !newlyAddedRecommendation.includes(item))
    window.sessionStorage.setItem("recommendation_draft", '')
    setRecommendationlistitems(savedRecommendations)
    setOpen(false)
    setEdited(false)
  }

  const handleClearAll = () => {
    setOpenClearAllConfirmation(true)
  }

  const confirmClearAll = () =>{
    recommendationlistitems.filter(item => !newlyAddedRecommendation.includes(item)).map((item) =>{
      dispatch(
        deleteRecommendationList(item.id,scope,findingRuleId,machine_type,hmi_type)
      )
    })
    window.sessionStorage.setItem("recommendation_draft",'')
    setRecommendationlistitems('')
    setOpen(false)
    setOpenClearAllConfirmation(false)
  }

  const handleDialogOpen = (scrollType) => {
    setOpen(true)
    setScroll(scrollType)
  }

  const handleCloseDialog = () => {
    setOpen(false)
  }

  const handleDeleteRecommendation = (id) => {
    const itemsExisting = recommendationlistitems.filter((item) => {
      return item.id !== id
    })
    setRecommendationlistitems(itemsExisting)
    window.sessionStorage.setItem("recommendation_draft", JSON.stringify(itemsExisting))
  }

  const handleAddRecommendation = (selectedDialogEntities) => {
    setNewlyAddedRecommendation([...newlyAddedRecommendation, selectedDialogEntities])
    var duplicateflag = false
    if (recommendationlistitems) {
      recommendationlistitems.map((item) => {
        if (item.id === selectedDialogEntities.id) {
          duplicateflag = true
        }
      })
    }
    if (!duplicateflag || !recommendationlistitems) {
      const dataToStore = [...recommendationlistitems, selectedDialogEntities];
      setRecommendationlistitems(dataToStore)
      window.sessionStorage.setItem("recommendation_draft", JSON.stringify(dataToStore))
    }
    handleCloseDialog()
  }

  const callErrorHandling = (errorMsg, severity) => {
    setErrorFlag(true)
    setErrorMsg(errorMsg)
    setErrorSeverity(severity)
  }

  const handleClose = () => {
    setErrorFlag(false)
    setNotificationFlag(false)
  }

  const onDragEnd = (result) => {
    if (!result.destination || edited === false) {
      return
    }
    const items = reorder(
      recommendationlistitems,
      result.source.index,
      result.destination.index
    )
    setRecommendationlistitems(items)
  }

  const reorder = (list, startIndex, endIndex) => {
    const result = Array.from(list)
    const [removed] = result.splice(startIndex, 1)
    result.splice(endIndex, 0, removed)
    return result
  }

  const getItemStyle = (isDragging, draggableStyle) => ({
    // styles we need to apply on draggables
    ...draggableStyle,
    ...(isDragging && {
      background: '#F6F6F6',
    }),
  })

  const getListStyle = (isDraggingOver) => ({
    background: isDraggingOver ? 'lightblue' : 'white',
  })

  return (
    <div className={classes.root}>
      <Accordion>
        <AccordionSummary
          expandIcon={<ExpandMoreIcon className='text-white' />}
          aria-controls='panel1a-content'
          id='panel1a-header'
          className={classes.accordion}
        >
          <Typography className='text-white'>Recommendations</Typography>
        </AccordionSummary>
        <AccordionDetails className='recommendationList'>
          {/* Message   */}
          <Snackbar
            open={errorflag ? true : false}
            autoHideDuration={6000}
            onClose={handleClose}
          >
            <Alert onClose={handleClose} severity={errorseverity}>
              {errormsg}
            </Alert>
          </Snackbar>
          {/* success notification */}
          <Snackbar
            open={notificationFlag.state ? true : false}
            autoHideDuration={6000}
            onClose={handleClose}
          >
            <Alert onClose={handleClose} severity={errorseverity}>
              {notificationFlag.message}
            </Alert>
          </Snackbar>
          <Typography>
          {!edited? 'If you want to edit the ranking of recommendations, please rearrange each recommendations by dragging and dropping on the desired rank slot.' : ''}
          </Typography>
          {/* Messgae - End */}
          {edited ? (
            <Grid container>
              <Button
                className={`btn-primary ${classes.editButton}`}
                onClick={() => handleRecommendationDone()}
              >
                Save
              </Button>
              <Button
                className={`btn-outlined`}
                variant='outlined'
                disabled= {recommendationlistitems.length === 0 ? true :  false}
                onClick={() => handleClearAll()}
                style={{ marginLeft: 'auto' }}
              >
                CLEAR ALL
              </Button>
              <Button
                className={`btn-outlined`}
                variant='outlined'
                style={{ marginRight: '0'}}
                onClick={() => handleDiscard()}
              >
                DISCARD
              </Button>
              {/* <DiscardDialog /> */}
            </Grid>
          ) : (
            <Button
              className={`btn-primary ${classes.editButton}`}
              onClick={() => setEdited(true)}
            >
              EDIT
            </Button>
          )}
          {recommendation.error && (
            <>
              <SkeletonList />
              <Snackbar
                message={recommendation.error}
                open={true}
                onClose={() => setErrorState(false)}
                autoHideDuration={3000}
              />
            </>
          )}

          <div style={{ overflow: 'auto', height: '300px' }}>
            <DragDropContext onDragEnd={onDragEnd}>
              <Droppable droppableId='droppable'>
                {(provided, snapshot) => (
                  <RootRef rootRef={provided.innerRef}>
                    <List style={getListStyle(snapshot.isDraggingOver)}>
                      <div className='listHeader'>
                        <ListSubheader>Rank</ListSubheader>
                        <ListSubheader>Recommendation</ListSubheader>
                        <ListSubheader>Effort</ListSubheader>
                        <ListSubheader>Role</ListSubheader>
                      </div>
                      {recommendation.loading && <SkeletonPaper row={1} />}
                      {!recommendation.recommendationLoading &&
                        recommendationlistitems.length > 0 &&
                        recommendationlistitems.map((item, index) => (
                          <Draggable
                            key={item.id.toString()}
                            draggableId={item.id.toString()}
                            index={index}
                            className='listContainer'
                          >
                            {(provided, snapshot) => (
                              <ListItem
                                ContainerComponent='li'
                                ContainerProps={{ ref: provided.innerRef }}
                                {...provided.draggableProps}
                                className={classes.listItem}
                                style={getItemStyle(
                                  snapshot.isDragging,
                                  provided.draggableProps.style
                                )}
                              >
                                <ListItemText>{index + 1} </ListItemText>
                                {alwaysHide ? (
                                  <ListItemText>{item.id}</ListItemText>
                                ) : //<ListItemText></ListItemText>
                                null}
                                <ListItemText>
                                 <span  {...provided.dragHandleProps}> {edited ? (
                                    <DragIndicatorRoundedIcon
                                      className={classes.dragIcon}
                                    />
                                  ) : null}
                                  </span>
                                  {item.description}
                                  
                                </ListItemText>
                                <ListItemText>{item.effort}</ListItemText>
                                <ListItemText>{item.department}</ListItemText>
                                {edited ? (
                                  <ListItemSecondaryAction>
                                    <IconButton
                                      onClick={() =>
                                        handleDeleteRecommendation(item.id)
                                      }
                                    >
                                      <DeleteOutlinedIcon />
                                    </IconButton>
                                  </ListItemSecondaryAction>
                                ) : (
                                  <ListItemSecondaryAction></ListItemSecondaryAction>
                                )}
                              </ListItem>
                            )}
                          </Draggable>
                        ))}
                      {provided.placeholder}
                    </List>
                  </RootRef>
                )}
              </Droppable>
            </DragDropContext>
          </div>
          {edited ? (
            <div>
              {' '}
              <Button
                className={`btn-primary`}
                style={{marginLeft:0}}
                onClick={() => handleDialogOpen('paper')}
              >
                + Add
              </Button>
              {open && (
                <RecommendationDialog
                  open={open}
                  scroll={scroll}
                  allRecommendation={allRecommendation}
                  handleCloseDialog={handleCloseDialog}
                  handleAddRecommendation={handleAddRecommendation}
                />
              )}
              {openClearAllConfirmation && <Dialog
              open={openClearAllConfirmation}
              PaperProps={{style: { width: "1000px", height:"135px", padding: "5px", overflow:"hidden" },}}
              >
                <DialogTitle >
                  Are you sure you want to clear all recommendations?
                </DialogTitle>
                <DialogActions>
                  <Button style={{width: '80px'}} onClick={confirmClearAll}>Yes</Button>
                  <Button style={{width: '80px'}} onClick={()=>setOpenClearAllConfirmation(false)}>Cancel</Button>
              </DialogActions>
              </Dialog>
              }
            </div>  
          ) 
          : 
          (
            <div></div>
          )}
        </AccordionDetails>
      </Accordion>
    </div>
  )
}

export default RecommendationList
